import { Card } from "primereact/card";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { MultiSelectPlayers } from "../../dropdowns/MultiSelectPlayers";
import { Column } from "primereact/column";
import { MultiSelectGames } from "../../dropdowns/MultiSelectGames";
import { useGames } from "../../../GamesProvider";
import { sortAnalysisToList } from "../../stats_components/AnalysisFive";
import PlannerTimeAndNumber from "../Helpers/PlannerTimeAndNumber";
import TimeFilters from "../Helpers/TimeFilters";
import Facilities from "../Helpers/Facilities";
const TeamPlanner = (props) => {

    const [selectedUsers, setSelectedUsers] = useState([]);
    const [displayedPlayers, setDisplayedPlayers] = useState([]);
    const [allUserAccounts] = useState(props.allUserAccounts);
    useEffect(() => {
        if (selectedUsers.length > 0) {
            setDisplayedPlayers(selectedUsers);
        } else {
            setDisplayedPlayers(allUserAccounts)
        }
    }, [selectedUsers, allUserAccounts])
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [totalMinutes, setTotalMinutes] = useState(0);
    const [elements, setElements] = useState(1);
    const [roundType, setRoundType] = useState("All");
    const [numberOfRounds, setNumberOfRounds] = useState(10);
    const [timeDuration, setTimeDuration] = useState(0);
    const [durationType, setDurationType] = useState("number");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [custom, setCustom] = useState(false);
    const [stats, setStats] = useState(null);
    const roundTypes = ["All", "Tournament", "Qualifying", "Practice"]
    const durations = ["Last Round", "Last 3 Rounds", "Last 4 Rounds", "Last 10 Rounds", "Last 15 Rounds",
        "Last 20 Rounds", "Last 30 Rounds", "Last Month", "Last 3 Months", "Last 6 Months", "Last 12 Months", "Fall", "Spring", "Custom"];
    const green = "rgba(0, 128, 0, 0.75)";
    const red = "rgba(220, 0, 0, 0.75)"
    const [numberImprovement, setNumberImprovement] = useState(2);
    const [numberStrength, setNumberStrength] = useState(1);
    const [units, setUnits] = useState("yards")

    const [loadingButton, setLoadningButton] = useState(false)

    const [dataState, setDataState] = useState([]);

    const gamesConst = useGames();
    const [selectedGames, setSelectedGames] = useState({});


    const facilities = ["Range Driver", "Range Irons", "Range Woods", "Short Game Area", "Putting Green"];
    const [selectedFacilities, setSelectedFacilities] = useState(facilities);
    const [statsType, setStatsType] = useState("Basic");


    useEffect(() => {
        switch (elements) {
            case 3:
                setNumberImprovement(2);
                setNumberStrength(1);
                break;
            case 4:
                setNumberImprovement(3);
                setNumberStrength(1);
                break;
            case 5:
                setNumberImprovement(3);
                setNumberStrength(2);
                break;
            case 6:
                setNumberImprovement(4);
                setNumberStrength(2);
                break;
            case 7:
                setNumberImprovement(5);
                setNumberStrength(2);
                break;
            case 8:
                setNumberImprovement(5);
                setNumberStrength(3);
                break;
            case 9:
                setNumberImprovement(6);
                setNumberStrength(3);
                break;
            case 10:
                setNumberImprovement(7);
                setNumberStrength(3);
                break;
        }
    }, [elements])
    useEffect(() => {
        setTotalMinutes(hours * 60 + minutes)
    }, [hours, minutes])

    /**
   * Gets rounds from selected user's database depending on user's selection.
   * @param {string} durationType - wheter time/number of rounds/custom/tournament
   * @param {int} timeDuration - how many months back
   * @param {int} numberOfRounds - how many last rounds
   * @param {string} roundType - type of rounds to get
   */
    function getSelectedRounds(durationType, timeDuration, numberOfRounds, roundType, selectedUserId) {

        if (durationType.toLowerCase() === "time") {
            fetch(`/api/Calculation/user-last-duration?timeType=month&duration=${timeDuration}&userId=${selectedUserId}&roundType=${roundType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    setDataState((prev) => [
                        ...prev,
                        { userId: selectedUserId, stats: sortAnalysisToList(data, units, selectedFacilities, numberImprovement, numberStrength, totalMinutes, statsType !== "Basic"), dataLoaded: true }
                    ])
                })
                .catch(error => {
                    console.error(error);
                });
        } else if (durationType.toLowerCase() === "number") {
            fetch(`/api/Calculation/user-last?numberOfRounds=${numberOfRounds}&userId=${selectedUserId}&roundType=${roundType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    setDataState((prev) => [
                        ...prev,
                        { userId: selectedUserId, stats: sortAnalysisToList(data, units, selectedFacilities, numberImprovement, numberStrength, totalMinutes, statsType !== "Basic"), dataLoaded: true }
                    ])
                })
                .catch(error => {
                    console.error(error);
                });
        } else if (durationType.toLowerCase() === "custom" && startDate !== null && endDate !== null) {
            fetch(`/api/Calculation/user-date-range?startDate=${startDate.toISOString().substring(0, 10)}&endDate=${endDate.toISOString().substring(0, 10)}&userId=${selectedUserId}&roundType=${roundType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    setDataState((prev) => [
                        ...prev,
                        { userId: selectedUserId, stats: sortAnalysisToList(data, units, selectedFacilities, numberImprovement, numberStrength, totalMinutes, statsType !== "Basic"), dataLoaded: true }
                    ])
                })
                .catch(error => {
                    console.error(error);
                });
        } else if (durationType.toLowerCase() === "fall") {
            fetch(`/api/Calculation/user-date-range?startDate=${"2023-08-25"}&endDate=${"2023-10-29"}&userId=${selectedUserId}&roundType=${roundType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    setDataState((prev) => [
                        ...prev,
                        { userId: selectedUserId, stats: sortAnalysisToList(data, units, selectedFacilities, numberImprovement, numberStrength, totalMinutes, statsType !== "Basic"), dataLoaded: true }
                    ])
                })
                .catch(error => {
                    console.error(error);
                });
        } else if (durationType.toLowerCase() === "spring") {
            fetch(`/api/Calculation/user-date-range?startDate=${"2023-02-10"}&endDate=${"2023-05-01"}&userId=${selectedUserId}&roundType=${roundType}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    setDataState((prev) => [
                        ...prev,
                        { userId: selectedUserId, stats: sortAnalysisToList(data, units, selectedFacilities, numberImprovement, numberStrength, totalMinutes, statsType !== "Basic"), dataLoaded: true }
                    ])
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }

    function sendEmail(name, userId, email) {
        var subject = `Practice ${name}`
        var time = dataState.filter((d) => d.userId === userId.substring(userId.indexOf('|') + 1))
            .map((d) => d.stats)[0].map((s) => `${s.name}: ${s.time}min%0D%0A`).join('');
        var puttingGames = selectedGames[userId].puttingGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";
        var argGames = selectedGames[userId].argGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";
        var appGames = selectedGames[userId].appGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";
        var teeGames = selectedGames[userId].teeGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";
        var combineGames = selectedGames[userId].combineGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";

        var body = `Time:%0D%0A${time}%0D%0A Putting games:%0D%0A${puttingGames}%0D%0A Arg games:%0D%0A${argGames}%0D%0A Approach games:%0D%0A${appGames}%0D%0A Tee games:%0D%0A${teeGames}%0D%0A Combines:%0D%0A${combineGames}`
        window.open(`mailto:${email}?subject=${subject} &body=${body}`, '_blank')
    }

    return (
        <div>
            <Card className="mt-2 mb-2" title="Plan players' day" >
                <PlannerTimeAndNumber hours={hours} setHours={setHours} minutes={minutes} setMinutes={setMinutes}
                    elements={elements} setElements={setElements} />
                <TimeFilters roundType={roundType} setRoundType={setRoundType} durations={durations} setNumberOfRounds={setNumberOfRounds}
                    setDurationType={setDurationType} setTimeDuration={setTimeDuration} setCustom={setCustom} statsType={statsType} setStatsType={setStatsType} />
                <div>
                    <MultiSelectPlayers players={props.players} selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers} durations={durations} coachTeam={props.coachTeam} />
                </div>
                <Facilities selectedFacilities={selectedFacilities} setSelectedFacilities={setSelectedFacilities} statsType={statsType} />
                <Button loading={loadingButton} className="m-2" disabled={totalMinutes <= 0 || selectedUsers.length <= 0} label="Plan my practice"
                    onClick={() => {
                        setDataState([])
                        selectedUsers.map((u) => {
                            getSelectedRounds(durationType, timeDuration, numberOfRounds, roundType, u.userId.substring(u.userId.indexOf('|') + 1))
                        })
                    }}
                />
            </Card >
            {<div>
                <Card className="mt-2 mb-2" title="Suggested Practice">

                    {selectedUsers.map((u) => {
                        return (
                            <Card className="m-2" title={u.name}>

                                <DataTable value={dataState.filter((d) => d.userId === u.userId.substring(u.userId.indexOf('|') + 1))
                                    .map((d) => d.stats)[0]}>
                                    <Column field="name" header="Name"></Column>
                                    <Column field="value" header="Total SG"></Column>
                                    <Column field="time" header="Time"></Column>
                                </DataTable>
                                <MultiSelectGames games={gamesConst.puttingGames} selectedGames={selectedGames[u.userId]?.puttingGames || []}
                                    setSelectedGames={(games) => {
                                        setSelectedGames((prevSelectedGames) => ({
                                            ...prevSelectedGames,
                                            [u.userId]: {
                                                ...prevSelectedGames[u.userId],
                                                puttingGames: games,
                                            },
                                        }));
                                    }} part="Putting" />
                                <MultiSelectGames games={gamesConst.argGames} selectedGames={selectedGames[u.userId]?.argGames || []}
                                    setSelectedGames={(games) => {
                                        setSelectedGames((prevSelectedGames) => ({
                                            ...prevSelectedGames,
                                            [u.userId]: {
                                                ...prevSelectedGames[u.userId],
                                                argGames: games,
                                            },
                                        }));
                                    }} part="Arg" />
                                <MultiSelectGames games={gamesConst.appGames} selectedGames={selectedGames[u.userId]?.appGames || []}
                                    setSelectedGames={(games) => {
                                        setSelectedGames((prevSelectedGames) => ({
                                            ...prevSelectedGames,
                                            [u.userId]: {
                                                ...prevSelectedGames[u.userId],
                                                appGames: games,
                                            },
                                        }));
                                    }} part="Approach" />
                                <MultiSelectGames games={gamesConst.teeGames} selectedGames={selectedGames[u.userId]?.teeGames || []}
                                    setSelectedGames={(games) => {
                                        setSelectedGames((prevSelectedGames) => ({
                                            ...prevSelectedGames,
                                            [u.userId]: {
                                                ...prevSelectedGames[u.userId],
                                                teeGames: games,
                                            },
                                        }));
                                    }} part="Tee" />
                                <MultiSelectGames games={gamesConst.combineGames} selectedGames={selectedGames[u.userId]?.combineGames || []}
                                    setSelectedGames={(games) => {
                                        setSelectedGames((prevSelectedGames) => ({
                                            ...prevSelectedGames,
                                            [u.userId]: {
                                                ...prevSelectedGames[u.userId],
                                                combineGames: games,
                                            },
                                        }));
                                    }} part="Combine" />
                                <div>
                                    <label>Selected games:</label>
                                    {selectedGames[u.userId]?.puttingGames?.map((game) => (
                                        <li>{game.name}</li>
                                    ))}
                                    {selectedGames[u.userId]?.argGames?.map((game) => (
                                        <li>{game.name}</li>
                                    ))}
                                    {selectedGames[u.userId]?.appGames?.map((game) => (
                                        <li>{game.name}</li>
                                    ))}
                                    {selectedGames[u.userId]?.teeGames?.map((game) => (
                                        <li>{game.name}</li>
                                    ))}
                                    {selectedGames[u.userId]?.combineGames?.map((game) => (
                                        <li>{game.name}</li>
                                    ))}
                                </div>
                                <Button label="Send" onClick={() => sendEmail(u.name, u.userId, u.email)} />

                            </Card>)
                    })}
                </Card>
            </div>}
        </div >
    )

}
export { TeamPlanner }